/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { CosmosClickableBox as CosmosClickableBoxRoot } from "./CosmosClickableBox";
import { CosmosClickableBoxLink } from "./CosmosClickableBoxLink";

import type { CosmosClickableBoxProps } from "./CosmosClickableBox";
import type { CosmosClickableBoxLinkProps } from "./CosmosClickableBoxLink";

const CosmosClickableBox: typeof CosmosClickableBoxRoot & {
	Link: typeof CosmosClickableBoxLink;
	Root: typeof CosmosClickableBoxRoot;
} = Object.assign(CosmosClickableBoxRoot, {
	Link: CosmosClickableBoxLink,
	Root: CosmosClickableBoxRoot,
});

export { CosmosClickableBox, CosmosClickableBoxLink };

export type { CosmosClickableBoxProps, CosmosClickableBoxLinkProps };
